import OverView from './components/OverView';
import css from './riverpro.module.scss';
import { getDetaileMoreProducts, intlNumber } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace, TextModule } from '@/componentsH5/ProductComponents';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import { BannerModule, TextWithImage, SwitchTabModule, TabModule } from '@/componentsH5/ProductDetailComponents';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointRiverBase from '@/components/AppPoint/RiverBaseH5';
import { SHOW_APP_POINT_SITES } from '@/constants';

const webpUrl = '/media/riverpro/h5/';
const { EFPic } = createEFPic(webpUrl);

export default function RiverPro() {
    const { gloproductlist, useLang, useRouter, useRef, Link } = useGlobal();
    const { t } = useLang('riverproportablepowerstation');
    const videoRef1 = useRef(null);
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['uk', 'au', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/3cIMpmRHbGo',
        cn: {
            SD: 'https://videos.ecoflow.com/5ae9d6d62cef43ccb9f454303686faab/f11e3203028443c39427617338128728-a6a7baf7ef7b18b463fed19f321bf1f3-fd.mp4',
            HD: 'https://videos.ecoflow.com/5ae9d6d62cef43ccb9f454303686faab/f11e3203028443c39427617338128728-d80b2a6a565bb18e6ac7f897a3f09096-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/efdc6b4-182edd3d95a-0004-9c91-e6d-40030.mp4',
        },
    };

    const banner_items = [
        {
            bgImgs: [`riverpro-banner_${imgSpec}.webp`, `riverpro-banner_${imgSpec}.jpg`],
            title: t('river_pro.banner_title'),
            des: t('river_pro.banner_desc'),
            video_src: videoSourceMap[locale] || videoSourceMap.us,
        },
    ];

    const text = [
        {
            title: t('river_pro.PFTLH'),
            des: t('river_pro.PFTLH_desc'),
        },
    ];

    const textWithImgItem1 = {
        title: t('river_pro.AC_output'),
        synopsis: t('river_pro.MPTY'),
        desc: t.rich('river_pro.MPTY_desc', {
            line1: (text: string) => (
                <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                    {text}
                </Link>
            ),
        }),
        noUseHtmlAttr: true,
        img_url: ['output_1.webp', 'output_1.png'],
    };

    const textWithImgItem2 = {
        synopsis: t('river_pro.POM'),
        alt: t('river_pro_peace'),
        desc: t('river_pro.POM_desc'),
        img_url: ['battery.webp', 'battery.png'],
    };

    const textWithImgItem3 = {
        synopsis: t('river_pro.FLOTG_H5'),
        alt: t('river_pro_life'),
        desc: t('river_pro.FLOTG_desc'),
        img_url: [`app_${appImgLocal}.webp`, `app_${appImgLocal}.jpg`],
    };

    const switchTab = [
        {
            tab: t('X-Stream AC Charging'),
            subTab: 'DELTA Pro is compatible ',
            key: 'k1',
            imgUrl: ['ac.webp', 'ac.png'],
            textDesc: t.rich('river_pro.ITWF_desc', {
                line1: (text: string) => (
                    <Link className="ef-link__page is-mobile" href="/x-stream" newWin>
                        {text}
                    </Link>
                ),
            }),
            showVideo: false,
        },
        {
            tab: t('Solar Charging'),
            subTab: 'DELTA Pro is compatible ',
            key: 'k2',
            imgUrl: ['output.webp', 'output.jpg'],
            textDesc: t('river_pro.SPGOGIE_desc'),
            showVideo: false,
        },
        {
            tab: t('Car Outlet Charging'),
            subTab: 'DELTA Pro is compatible ',
            key: 'k3',
            imgUrl: [`carCharging_${imgSpec}.webp`, `carCharging_${imgSpec}.jpg`],
            textDesc: t('river_pro.CO_desc'),
            showVideo: false,
        },
    ];

    const tabData = [
        {
            tab: t('river_pro.HB'),
            key: 'k1',
            arr: [
                {
                    key: 'code1',
                    images: '/media/riverpro/h5/icons/homeBc01.svg',
                    name: t('river_pro.Light'),
                    value: intlNumber(locale, 65.2),
                    unit: t('Hrs'),
                },
                {
                    key: 'code3',
                    images: '/media/riverpro/h5/icons/homeBc03.svg',
                    name: t('river_pro.Refrigerator'),
                    value: intlNumber(locale, 4.5),
                    unit: t('Hrs'),
                },
                {
                    key: 'code4',
                    images: '/media/riverpro/h5/icons/homeBc04.svg',
                    name: t('river_pro.Blender'),
                    value: intlNumber(locale, 1.2),
                    unit: t('Hrs'),
                },
                {
                    key: 'code5',
                    images: '/media/riverpro/h5/icons/homeBc05.svg',
                    name: t('river_pro.50 TV'),
                    value: '5',
                    unit: t('Hrs'),
                },
                {
                    key: 'code6',
                    images: '/media/riverpro/h5/icons/homeBc06.svg',
                    name: t('river_pro.Hair Dryer'),
                    value: intlNumber(locale, 0.7),
                    unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                },
                {
                    key: 'code7',
                    images: '/media/riverpro/h5/icons/homeBc07.svg',
                    name: t('river_pro.Coffee Maker'),
                    value: intlNumber(locale, 0.7),
                    unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                },
                {
                    key: 'code8',
                    images: '/media/riverpro/h5/icons/homeBc08.svg',
                    name: t('river_pro.Projector'),
                    value: '8',
                    unit: t('Hrs'),
                },
                {
                    key: 'hide9',
                    unit: ' ',
                },
            ],
        },
        {
            tab: t('river_pro.OG'),
            key: 'k2',
            arr: [
                {
                    key: 'code1',
                    images: '/media/riverpro/h5/icons/offGL01.svg',
                    name: t('river_pro.Phone'),
                    value: '59',
                    unit: t('Hrs'),
                },
                {
                    key: 'code2',
                    images: '/media/riverpro/h5/icons/offGL02.svg',
                    name: t('river_pro.Laptop'),
                    value: '10',
                    unit: t('Times'),
                },
                {
                    key: 'code3',
                    images: '/media/riverpro/h5/icons/offGL03.svg',
                    name: t('river_pro.Camera'),
                    value: '40',
                    unit: t('Times'),
                },
                {
                    key: 'code4',
                    images: '/media/riverpro/h5/icons/offGL04.svg',
                    name: t('river_pro.Speaker'),
                    value: intlNumber(locale, 22.2),
                    unit: t('Hrs'),
                },
                {
                    key: 'code5',
                    images: '/media/riverpro/h5/icons/offGL05.svg',
                    name: t('river_pro.Drone'),
                    value: '16',
                    unit: t('Times'),
                },
                {
                    key: 'code6',
                    images: '/media/riverpro/h5/icons/offGL06.svg',
                    name: t('river_pro.Electric Kettle'),
                    value: intlNumber(locale, 0.7),
                    unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                },
                {
                    key: 'code7',
                    images: '/media/riverpro/h5/icons/offGL07.svg',
                    name: t('river_pro.Electric Frying Pan'),
                    value: intlNumber(locale, 0.7),
                    unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                },
                {
                    key: 'code8',
                    images: '/media/riverpro/h5/icons/offGL08.svg',
                    name: t('river_pro.Rice Cooker'),
                    value: intlNumber(locale, 0.7),
                    unit: locale === 'de' ? t('OneHrs') : t('Hrs'),
                },
            ],
        },
    ];

    return (
        <div className={`${css.animationWrapper}`}>
            <div style={{ width: '100%' }} className="banners">
                <BannerModule
                    config={{
                        position: 'top',
                        theme: 'black',
                        isShowLogo: false,
                        isShowVideo: true,
                        webpUrl,
                    }}
                    data={banner_items}
                />
            </div>
            {/* 新版本一图看懂 */}
            <OverView></OverView>
            <div className="capacity">
                <h4>
                    <span>{t('river_pro.EC')}</span>
                </h4>
                <div className="content">
                    <EFVideo
                        ref={videoRef1}
                        className="video"
                        sources={[`/video/riverpro-h5/720-1440_${imgSpec}.webm`, `/video/riverpro-h5/720-1440_${imgSpec}.mp4`]}
                        playTrigger={500}
                        loop={false}
                    />
                </div>
            </div>
            <div className="text-wrap">
                <TextModule config={{ textAlign: 'left', desColor: '#777' }} data={text} />
                <div className="imgs-box">
                    <div className="imgs">
                        <EFPic name={['power.webp', 'power.png']} className="fullImgs" alt={t('river_pro_power')} />
                    </div>
                    <div className="imgs1">
                        <EFPic name={[`power1_${imgSpec}.webp`, `power1_${imgSpec}.png`]} className="fullImgs" alt={t('river_pro_power')} />
                    </div>
                </div>
            </div>

            <LineSpace height="xl" background="#fff" />
            <div className="textImageWrap textWithImgItem1">
                <TextWithImage
                    config={{
                        position: 'top',
                        text: 'left',
                        fullScreen: false,
                        descColor: '#919191',
                        webpUrl,
                    }}
                    data={textWithImgItem1}
                />
            </div>
            <LineSpace height={0.9} background="#fff" />
            <div className="tabModuleWrap">
                <TabModule data={tabData} config={{ position: 'top' }} />
            </div>
            <LineSpace height={1.2} background="#fff" />
            <div className="switchTab">
                <SwitchTabModule data={switchTab} cssStyle={{ webpUrl }} />
            </div>
            <LineSpace height="xxl" background="#fff" />
            <div className="textImageWrap textWithImgItem2">
                <TextWithImage
                    config={{
                        position: 'top',
                        text: 'left',
                        fullScreen: false,
                        descColor: '#919191',
                        webpUrl,
                    }}
                    data={textWithImgItem2}
                />
            </div>
            <LineSpace height={1.2} background="#fff" />
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="textImageWrap textWithImgItem3">
                    <TextWithImage
                        config={{
                            position: 'top',
                            text: 'left',
                            imgHeight: '4rem',
                            descColor: '#919191',
                            webpUrl,
                        }}
                        data={textWithImgItem3}
                    />
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <LineSpace height={1.2} background="#fff" />
            <div className="other">
                <OtherList data={getDetaileMoreProducts(gloproductlist, ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'])} />
            </div>
        </div>
    );
}
